import { useMsal } from '@azure/msal-react';
import { useState, useEffect } from 'react';

import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { revoke } from 'Auth/sources';

import { loginRequest } from './authConfig';

export const useMS = ({ signInOnLoad, onNoSession }) => {
  const { instance, accounts, inProgress } = useMsal();
  const [token, setToken] = useState(null);
  const logout = async () => {
    try {
      await revoke();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      instance.logoutPopup({
        postLogoutRedirectUri: '/v3',
        mainWindowRedirectUri: '/v3',
      });
    }
  };

  const login = async () => {
    const p = instance.acquireTokenPopup(loginRequest);

    p.then((tokenResponse) => {
      setToken(tokenResponse.idToken);
    }).catch(() => {
      setToken(null);
    });

    return p;
  };

  useEffect(() => {
    if (signInOnLoad) {
      let request = { ...loginRequest };
      if (accounts?.[0]) {
        request.account = accounts?.[0];
      }

      instance
        .acquireTokenSilent(request)
        .then((response) => {
          setToken(response.idToken);
        })
        .catch(() => {
          onNoSession();
        });
    }
  }, [signInOnLoad]);

  return {
    _hasError: false,
    _name: 'ms',
    loaded: inProgress === 'none',

    login: login,
    logout: logout,
    active: false,

    getAccessToken: async () => {
      const requestToken = {
        scopes: ['openid', 'profile', 'email', 'offline_access'],
      };
      if (accounts?.[0]) {
        requestToken.account = accounts?.[0];
      }
      const tokenResponse = await instance
        .acquireTokenSilent(requestToken)
        .catch(async (error) => {
          try {
            if (error instanceof InteractionRequiredAuthError) {
              return await instance.acquireTokenPopup(requestToken);
            }
          } catch (e) {
            onNoSession();
          }
        });
      return tokenResponse.idToken;
    },
    isAuthenticated: !!token,
    onUnauthorized: () => {
      setToken(null);
      logout();
    },
  };
};
